import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { toast } from "react-toastify";
import {
  useProgramCategories,
  useResourceCategories,
} from "../../hooks/useRedux";
import CategoryForm from "./CategoryForm";
import { Category } from "../../store/slices/types";

const AddCategory: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isProgramCategories = location.pathname.includes("program-categories");

  const programCategoriesHook = useProgramCategories();
  const resourceCategoriesHook = useResourceCategories();

  const { createCategory } = isProgramCategories
    ? programCategoriesHook
    : resourceCategoriesHook;

  const handleSave = async (categoryData: Partial<Category>) => {
    try {
      const newCategory = {
        name: categoryData.name || "",
        description: categoryData.description || "",
        isActive:
          categoryData.isActive !== undefined ? categoryData.isActive : true,
        createdBy: "admin",
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };

      await createCategory(newCategory);
      toast.success("category is created");
      navigate(
        isProgramCategories ? "/program-categories" : "/resource-categories"
      );
    } catch (error) {
      console.error("Failed to create category:", error);
      toast.error(
        `❌ Failed to create category: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate(
      isProgramCategories ? "/program-categories" : "/resource-categories"
    );
  };

  const categoryType = isProgramCategories ? "Program" : "Resource";

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Create New {categoryType} Category
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Add a new {categoryType.toLowerCase()} category to your library
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <CategoryForm
          category={null}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default AddCategory;
